import * as React from 'react'
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select'
import { useChargebeePlans } from '../../plans/api/get-chargebee-plans'
import { ChevronDown } from 'lucide-react'
import { ChargebeePlan } from '@/features/plans/types/chargebee'

type ChargeBeePlansDropdownProps = {
    value?: string | null
    onChange: (planId: string | null, plan?: ChargebeePlan) => void
    placeholder?: string
    disabled?: boolean
    className?: string
}

const currency = new Intl.NumberFormat(undefined, { style: 'currency', currency: 'USD' })

export default function ChargeBeePlansDropdown({ value, onChange, placeholder = 'Select a chargebee plan', disabled, className }: ChargeBeePlansDropdownProps) {
    const { data, isLoading, error } = useChargebeePlans({})

    const plans = data ?? [] as ChargebeePlan[]
    const selected = plans.find((p) => p.id === value) || null

    const disabledLabel = isLoading ? 'Loading…' : (error ? 'Failed to load plans' : placeholder)

    return (
        <Select
            value={value ?? ''}
            onValueChange={(val) => {
                const plan = plans.find((p) => p.id === val) || undefined
                onChange(val || null, plan)
            }}
            disabled={disabled || isLoading || !!error}
        >
            <SelectTrigger className={className}>
                <SelectValue placeholder={disabledLabel} />
            </SelectTrigger>
            <SelectContent>
                {plans.map((plan) => (
                    <SelectItem key={plan.id} value={plan.id}>
                        {plan.name} ({plan.id}) · {currency.format(plan.price ?? 0)}
                    </SelectItem>
                ))}
            </SelectContent>
        </Select>
    )
}


